import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {HomeComponent} from './components/pages/home/home.component';
import {ApplyNowComponent} from './components/pages/apply-now/apply-now.component';

const routes: Routes = [
    { path: '', component: HomeComponent },
    {
        path: 'application-process',
        loadChildren: () =>
            import('./components/pages/application-process/application-process.module').then((m) => m.ApplicationProcessModule),
    },
    {
        path: 'contact-us',
        loadChildren: () => import('./components/pages/contact-us/contact-us.module').then((m) => m.ContactUsModule),
    },
    {
        path: 'about',
        loadChildren: () => import('./components/pages/about/about.module').then((m) => m.AboutModule),
    },
    {
        path: 'apply-now',
        // tslint:disable-next-line:max-line-length
        component: ApplyNowComponent,
    },
    { path: '**', redirectTo: '', pathMatch: 'full' },

];

@NgModule({
    imports: [RouterModule.forRoot(routes, {relativeLinkResolution: 'legacy'})],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
